// extracted by mini-css-extract-plugin
export default {"modalContainer":"SuccessModal_modalContainer__Lrnvn","modal":"SuccessModal_modal__sp8-N","checkMark":"SuccessModal_checkMark__6dNJ8"};